import { MessageService } from './../../../../structure/service/message.service';
import { EnumTipoMensagem } from './../../../../structure/enum/enum-infra';
import { MessageInfra } from 'src/app/structure/message/message-infra';
import { JwtService } from './../../../../structure/service/auth/jwt.service';
import { Menu } from './../../../../shared/menu-items/menu-items';
import { MenuService } from './../../../../features/manutencao/menu/menu.service';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';

var menuItems = [];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  public listaMenu: Array<Menu> = new Array<Menu>();
  public listaMenuDinamico: Array<Menu> = new Array<Menu>();

  private _mobileQueryListener: () => void;
  status = true;

  itemSelect: number[] = [];
  parentIndex = 0;
  childIndex = 0;

  setClickedRow(i: number, j: number) {
    this.parentIndex = i;
    this.childIndex = j;
  }
  subclickEvent() {
    this.status = true;
  }
  scrollToTop() {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public  router: Router,
    public  menuService:MenuService,
    private jwtService: JwtService,
    private messageService: MessageService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void{
    this.getMenuitem();
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onNavigate = (url: string): void => {
    let currentUrl = this.router.url;
    url = "/" + url;

    this.router.navigateByUrl(url).then(() => {
      //location.reload()
      this.router.navigate([`${url}`]);
    });
  }

  onNavigateMenuDinamico = (url: string): void => {

    let currentUrl = this.router.url;
    url = "/" + url;

    this.router.navigateByUrl(url).then(() => {
      this.router.navigate([`${url}`]);
      window.location.reload()
    });
  }


  getMenuitem() {
    var usuarioDados = JSON.parse(this.jwtService.getUsuarioDados());
     if(this.listaMenu[0] != null) { return menuItems}
     this.menuService.getList(usuarioDados.Id).subscribe(res =>
     {
       this.listaMenu = res;
     });

    this.menuService.getListMenuDinamico().subscribe(res =>
      {
        this.listaMenuDinamico = res.data;

      });
  }

  sair()
  {
      this.jwtService.destroyToken();
      this.messageService.showNotify(MessageInfra.SessaoEncerrada, EnumTipoMensagem.Alerta);
      this.router.navigateByUrl('/authentication/login');
  }

  imagemEntidade()
  {
    var imagemEntidade = this.jwtService.getImagemEntidade();
    return imagemEntidade
  }

  imagemUsuario()
  {

    var imagemUsuario = this.jwtService.getImagemUsuario();
    return imagemUsuario
  }

  edicaoUsuario()
  {
    var usuario = this.jwtService.getUsuarioDadosJSON();
    this.router.navigateByUrl('/usuarios/usuario/'+usuario.Id);
  }

}
